
const getDateFormat = () => {
    return localStorage.getItem('dateFormat') || 'mm/dd/yyyy';
};

const setDateFormat = (format) => {
    localStorage.setItem('dateFormat', format);
};

const formatDate = (dateString) => {
    if (!dateString) return '';

    const format = getDateFormat();
    const date = new Date(dateString);
    const userTimezoneOffset = date.getTimezoneOffset() * 60000;
    const adjustedDate = new Date(date.getTime() + userTimezoneOffset);


    const day = String(adjustedDate.getDate()).padStart(2, '0');
    const month = String(adjustedDate.getMonth() + 1).padStart(2, '0');
    const year = adjustedDate.getFullYear();
    const monthName = adjustedDate.toLocaleString('en-US', { month: 'short' });

    switch (format) {
        case 'mm/dd/yyyy':
            return `${month}/${day}/${year}`;
        case 'month dd, yyyy':
            return `${monthName} ${day}, ${year}`;
        default:
            return `${month}/${day}/${year}`;
    }
};

const formatDateTime = (dateString) => {
    if (!dateString) return '';

    const format = getDateFormat();
    const timezone = localStorage.getItem('timezone') || 'UTC';
    const date = new Date(dateString);

    const options = {
        timeZone: timezone,
        year: 'numeric',
        month: format === 'month dd, yyyy' ? 'short' : '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
    };
    
    const formatter = new Intl.DateTimeFormat('en-US', options);
    const parts = formatter.formatToParts(date);

    const day = parts.find(p => p.type === 'day').value;
    const month = parts.find(p => p.type === 'month').value;
    const year = parts.find(p => p.type === 'year').value;
    let hour = parts.find(p => p.type === 'hour').value;
    const minute = parts.find(p => p.type === 'minute').value;
    
    if (hour === '24') {
        hour = '00';
    }

    let datePart;
    if (format === 'month dd, yyyy') {
        datePart = `${month} ${day}, ${year}`;
    } else {
        datePart = `${month}/${day}/${year}`;
    }

    return `${datePart} ${hour}:${minute}`;
};

export { formatDate, getDateFormat, setDateFormat, formatDateTime };
